/**
 * BannerCarouselCtrl controller
 */

// preload drag'n'drop image
const dragndropImg = new window.Image()
dragndropImg.src = require('./img/dragndrop.png')

// controller mixins
BannerCarouselCtrl.mixes = [
  'onOffCtrlMixin'
]

/**
 * BannerCarouselCtrl controller
 *
 * @class BannerCarouselCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 * @mixes mwApp/common.mixin:onOffCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:BannerCarouselCtrl
 */
/* @ngInject */
export default function BannerCarouselCtrl ($scope, $uibModal, alertSvc, pckg, Banner, BannerBundle, authSvc, alertLiteSvc, cts, bannerSubscriptions) {
  var vm = this

  /**
   * Network
   *
   * @memberof mwApp/packages.controller:BannerCarouselCtrl
   * @type {models.Network}
   */
  vm.pckg = pckg

  /**
   * Base Banners list
   *
   * @memberof mwApp/packages.controller:BannerCarouselCtrl
   * @type {[models.Banner]}
   */
  vm.carousels = []

  /**
   * Platforms array
   *
   * @memberof mwApp/packages.controller:BannerCarouselCtrl
   * @type {Object[]}
   */

  /**
   * Default values for table state
   *
   * @type {Object}
   */
  const defaultTableState = {
    page: 0,
    count: 25,
    name: '',
    last: false
  }

  // copy for table state
  vm.tableState = angular.copy(defaultTableState)

  // load banner info
  Banner.loadAll({ networkId: vm.pckg.id, params: vm.tableState }).then((result) => {
    vm.loadedBanner = true
    vm.carousels = result.content.map((ba) => {
      ba.networkId = vm.pckg.id // Hack! set networkId to banner bundle

      ba.bannerBundles.map((bb) => { // mixin ids
        bb.networkId = vm.pckg.id
        return bb
      })

      ba.$listOfSubscriptions = angular.copy(bannerSubscriptions.filter(s => !ba.subscriptions.find(sub => sub.id === s.id)))
      if (ba.$listOfSubscriptions.length) {
        ba.$listOfSubscriptions = [{ id: 0, name: 'All Subscriptions' }].concat(ba.$listOfSubscriptions)
      } else {
        ba.$listOfSubscriptions = [{ id: -1, name: 'Deselect all Subscriptions' }]
      }

      return new Banner(ba)
    })
  })

  vm.addBannerCarousel = function () {
    let subscriptionsForBanner
    if (!vm.carousels.length) {
      subscriptionsForBanner = [{ id: 0, name: 'All Subscriptions' }].concat(bannerSubscriptions)
    } else {
      if (vm.carousels[0].$listOfSubscriptions.filter(s => s.id > 0).length) {
        subscriptionsForBanner = angular.copy(vm.carousels[0].$listOfSubscriptions)
      } else {
        subscriptionsForBanner = []
      }
    }
    vm.carousels.push(new Banner({ $listOfSubscriptions: subscriptionsForBanner, networkId: vm.pckg.id }))
  }

  vm.deselectSubscription = function (banner, subscription, form) {
    form.$setDirty()
    form.subscription.$setTouched()
    banner.subscriptions = banner.subscriptions.filter(s => s.id !== subscription.id)
    banner.$listOfSubscriptions.shift()
    banner.$listOfSubscriptions = banner.$listOfSubscriptions.concat([subscription])
    if (banner.$listOfSubscriptions.length) {
      banner.$listOfSubscriptions = [{ id: 0, name: 'All Subscriptions' }].concat(banner.$listOfSubscriptions)
    } else {
      banner.$listOfSubscriptions = [{ id: -1, name: 'Deselect all Subscriptions' }]
    }
    vm.carousels.forEach(carousel => {
      if (!banner.$listOfSubscriptions.filter(s => s.id > 0).length && !carousel.subscription.length) {
        carousel.$listOfSubscriptions = []
      } else {
        carousel.$listOfSubscriptions = banner.$listOfSubscriptions
      }
    })

    banner.bannerBundles = banner.bannerBundles.filter(bb => {
      if (['CATEGORY', 'SUBCATEGORY'].includes(bb.contentType)) {
        return true
      }
      return !!bb.inSubscriptions.filter(sid => {
        return !!banner.subscriptions.find(s => s.id === sid)
      }).length
    })
    if (banner.subscriptions.length) {
      Banner.getPlatforms(vm.pckg.id, banner.subscriptions.map(s => s.id)).then(res => {
        banner.bannerBundles = banner.bannerBundles.filter(bb => {
          if (['CATEGORY', 'SUBCATEGORY'].includes(bb.contentType)) {
            return true
          }
          return !!bb.platformTypes.find(platform => {
            return res.includes(platform)
          }).length
        })
      })
    }
  }

  vm.selectSubscription = function (banner, form) {
    form.$setDirty()
    if (banner.$selectedSubscription.id === 0) {
      banner.$listOfSubscriptions.shift()
      banner.subscriptions = banner.subscriptions.concat(banner.$listOfSubscriptions)
      banner.$listOfSubscriptions = [{ id: -1, name: 'Deselect all Subscriptions' }]
    } else if (banner.$selectedSubscription.id === -1) {
      banner.$listOfSubscriptions = [{ id: 0, name: 'All Subscriptions' }].concat(banner.subscriptions)
      banner.subscriptions = []
      banner.bannerBundles = []
    } else {
      banner.subscriptions.push(banner.$selectedSubscription)
      banner.$listOfSubscriptions.shift()
      banner.$listOfSubscriptions = banner.$listOfSubscriptions.filter(s => !banner.subscriptions.find(sub => sub.id === s.id))
      if (banner.$listOfSubscriptions.length) {
        banner.$listOfSubscriptions = [{
          id: 0,
          name: 'All Subscriptions'
        }].concat(banner.$listOfSubscriptions.filter(s => !banner.subscriptions.find(sub => sub.id === s.id)))
      } else {
        banner.$listOfSubscriptions = [{ id: -1, name: 'Deselect all Subscriptions' }]
      }
    }
    vm.carousels.forEach(carousel => {
      if (banner.$listOfSubscriptions[0].id === -1 && !carousel.subscriptions.length) {
        carousel.$listOfSubscriptions = []
      } else {
        carousel.$listOfSubscriptions = banner.$listOfSubscriptions
      }
    })
  }

  vm.atLeastOneSubscription = function (ba) {
    return ba.subscriptions.length > 0
  }

  vm.carouselSubscriptions = function (banner) {
    return banner.subscriptions.map(s => s.name).join(', ')
  }

  /**
   * Delete carousel
   *
   * @memberof mwApp/packages.controller:BannerCarouselCtrl
   */
  vm.delete = function (carousel, index) {
    carousel.$listOfSubscriptions.shift()
    carousel.$listOfSubscriptions = carousel.$listOfSubscriptions.concat(carousel.subscriptions)
    if (carousel.$listOfSubscriptions.length) {
      carousel.$listOfSubscriptions = [{ id: 0, name: 'All Subscriptions' }].concat(carousel.$listOfSubscriptions)
    } else {
      carousel.$listOfSubscriptions = [{ id: -1, name: 'Deselect all Subscriptions' }]
    }
    if (carousel.id) {
      vm.setDisable()

      carousel._delete()
        .then(() => {
          vm.carousels.splice(index, 1)
          vm.carousels.forEach(c => {
            c.$listOfSubscriptions = carousel.$listOfSubscriptions
          })
          if (!vm.carousels.length) {
            Banner.getAvailableSubscriptions(vm.pckg.id).then(res => {
              bannerSubscriptions = res
            })
          }
        })
        .finally(vm.unsetDisable)
    } else {
      vm.carousels.splice(index, 1)
      vm.carousels.forEach(c => {
        c.$listOfSubscriptions = carousel.$listOfSubscriptions
      })
    }
  }

  /**
   * Show delete button for carousel
   *
   * @memberof mwApp/packages.controller:BannerCarouselCtrl
   */
  vm.showDeleteButton = function (carousel) {
    return authSvc.hasAccess('deleteBannerCarousel') || !carousel.id
  }

  /**
   * Add Banner Bundle (with modal)
   *
   * @memberof mwApp/packages.controller:BannerCarouselCtrl
   */
  vm.addBannerBundle = vm.editBannerBundle = function (ba, bb, $event, form) {
    vm.stopEvent($event)

    const isNew = !bb
    const initialBb = angular.copy(bb) // initial state
    $uibModal.open({
      templateUrl: 'components/packages/views/addBannerBundle.html',
      controller: 'AddBannerBundleCtrl as vm',
      animation: false,
      size: 'lg',
      resolve: {
        banner: function () { return ba },
        bb: function () {
          return !isNew
            ? bb
            : new BannerBundle({ $carouselId: ba.id, networkId: vm.pckg.id, subscriptionId: ba.subscriptionId })
        },
        isNew: () => isNew,
        contentTypes: () => cts
      }
    }).result
      .then(
        function close (data) {
          if (data.action === 'delete') {
            const index = ba.bannerBundles.findIndex((item) => item.id === bb.id)
            ba.bannerBundles.splice(index, 1)
          } else {
            if (['TV_CHANNEL', 'TV_SHOW', 'MOVIE'].includes(data.bb.contentType)) {
              Banner.getSubscriptionsByContent(vm.pckg.id, data.bb.$content.id, data.bb.contentType).then(res => {
                data.bb.inSubscriptions = res
                if (isNew) {
                  ba.bannerBundles.push(data.bb)
                }
              })
            } else {
              if (isNew) {
                ba.bannerBundles.push(data.bb)
              }
            }
          }
          form.$setDirty()
        },
        function dismiss () {
          if (!isNew) {
            angular.copy(initialBb, bb) // restore bundles
          }
        })
  }

  /**
   * Delete banner bundle
   *
   * @memberof mwApp/shows.controller:BannerCarouselCtrl
   * @param {model.Banner} ba - entity
   * @param {Number} index
   * @param {Object} form
   */
  vm.deleteBannerBundle = function (ba, index, form) {
    form.$setDirty()
    ba.bannerBundles.splice(index, 1)
  }

  /**
   * On/Off episode
   *
   * @memberof mwApp/shows.controller:BannerCarouselCtrl
   * @param {model.BannerBundle} bb - entity
   */
  vm.onOff = function (bb) {
    return bb._onOff()
  }

  /**
   * Create/update Banner
   *
   * @memberof mwApp/packages.controller:BannerCarouselCtrl
   */
  vm.save = function (ba, form, reassignSubscriptions = false) {
    if (!ba.bannerBundles.length) {
      return
    }
    vm.setDisable()
    ba.bannerBundles.forEach((bb, index) => {
      bb.sortOrder = index
    })
    ba._save(data => {
      data.bannerBundles.forEach(bb => {
        delete bb.inSubscriptions
      })
      data.reassignSubscriptions = reassignSubscriptions
      return data
    }, null, 'Banner Carousel created', 'Banner Carousel updated', true)
      .then(() => {
        ba._update()
          .then((result) => {
            form.$setPristine()
            ba = result
            ba.networkId = vm.pckg.id
            ba.$listOfSubscriptions = angular.copy(bannerSubscriptions.filter(s => !ba.subscriptions.find(sub => sub.id === s.id)))
            if (!ba.$listOfSubscriptions.length) {
              ba.$listOfSubscriptions = [{ id: -1, name: 'Deselect all Subscriptions' }]
            } else {
              ba.$listOfSubscriptions = [{ id: 0, name: 'All Subscriptions' }].concat(ba.$listOfSubscriptions)
            }
            ba.is_open = false
          })
      })
      .catch(err => {
        const startPos = err.data.indexOf('[') + 1
        const endPos = err.data.indexOf(']')
        if (startPos && endPos) {
          const str = err.data.slice(startPos, endPos)
          const subscrIds = str.split(', ').map(ids => +ids)
          const intersectionSubscriptions = ba.subscriptions.filter(s => subscrIds.includes(s.id))
          var msg = {
            text: 'Are You sure, that You want to override previous banner carousel for the Subscription(s)?',
            header: `Subscription ${intersectionSubscriptions.map(s => s.name).join(', ')} ${intersectionSubscriptions.length === 1 ? 'has' : 'have'} a banner carousel.`
          }

          alertSvc.confirm(msg)
            .then(
              () => {
                vm.save(ba, form, true)
              }
            )
        }
      })
      .finally(vm.unsetDisable)
  }

  /**
   * Link to hasAccess authSvc
   *
   * @memberof mwApp/packages.controller:BannerCarouselCtrl
   */
  vm.hasAccess = authSvc.hasAccess

  /**
   * Count of selected bundles
   *
   * @memberof mwApp/packages.controller:BannerCarouselCtrl
   * @param bundles
   * @returns Number
   */
  vm.countSelectedItems = function (bundles = []) {
    return bundles.filter(item => item.$highlighted).length
  }

  /**
   * Delete few bannerBundles from carousel
   *
   * @memberof mwApp/packages.controller:BannerCarouselCtrl
   */
  vm.deleteBundles = function (ba, form) {
    form.$setDirty()
    const items = []
    ba.bannerBundles.forEach(item => {
      if (item.$highlighted) {
        items.push(item)
      }
    })

    deleteAll(items)
      .then(() => ba._update())
      .finally(vm.unsetDisable)
  }

  vm.close = function (carousel, form, index) {
    if (carousel.id) {
      carousel._update()
        .then((result) => {
          form.$setPristine()
          carousel = result
          carousel.networkId = vm.pckg.id
          let $listOfSubscriptions = []
          if (vm.carousels.length > 0) {
            $listOfSubscriptions = vm.carousels.find(c => c.id !== carousel.id).$listOfSubscriptions.filter(s => s.id > 0)
          }
          $listOfSubscriptions = bannerSubscriptions.concat($listOfSubscriptions)
          const uniq = Array.from(new Set($listOfSubscriptions.map(s => s.id)))
          carousel.$listOfSubscriptions = []
          uniq.forEach(id => {
            carousel.$listOfSubscriptions.push($listOfSubscriptions.find(s => s.id === id))
          })
          carousel.$listOfSubscriptions = carousel.$listOfSubscriptions.filter(s => !carousel.subscriptions.find(sub => sub.id === s.id))
          if (!carousel.$listOfSubscriptions.length) {
            carousel.$listOfSubscriptions = [{ id: -1, name: 'Deselect all Subscriptions' }]
          } else {
            carousel.$listOfSubscriptions = [{ id: 0, name: 'All Subscriptions' }].concat(carousel.$listOfSubscriptions)
          }
          vm.carousels.forEach(c => {
            if (carousel.$listOfSubscriptions[0].id === -1 && !c.subscriptions.length) {
              c.$listOfSubscriptions = []
            } else {
              c.$listOfSubscriptions = carousel.$listOfSubscriptions
            }
          })
        })
      carousel.is_open = false
    } else {
      vm.carousels.splice(index, 1)
      carousel.$listOfSubscriptions.shift()
      carousel.$listOfSubscriptions = carousel.$listOfSubscriptions.concat(carousel.subscriptions)
      if (!carousel.$listOfSubscriptions.length) {
        carousel.$listOfSubscriptions = [{ id: -1, name: 'Deselect all Subscriptions' }]
      } else {
        carousel.$listOfSubscriptions = [{ id: 0, name: 'All Subscriptions' }].concat(carousel.$listOfSubscriptions)
      }
      vm.carousels.forEach(c => {
        if (carousel.$listOfSubscriptions[0].id === -1 && !c.subscriptions.length) {
          c.$listOfSubscriptions = []
        } else {
          c.$listOfSubscriptions = carousel.$listOfSubscriptions
        }
      })
    }
  }
  function deleteAll (items) {
    return items.length && items.pop()._delete().then(() => {
      return deleteAll(items)
    })
  }

  /**
   * dnd-dragging determines what data gets serialized and send to the receiver
   * of the drop. While we usually just send a single object, we send the array
   * of all selected items here.
   */
  vm.getSelected = function (list, link) {
    link.selected = true
    return list.filter(link => link.selected)
  }

  /**
   * We set the list into dragging state, meaning the items that are being
   * dragged are hidden. We also use the HTML5 API directly to set a custom
   * image, since otherwise only the one item that the user actually dragged
   * would be shown as drag image.
   */
  vm.onDragstart = function (list, event) {
    list.dragging = true
    if (event.dataTransfer.setDragImage) {
      event.dataTransfer.setDragImage(dragndropImg, 0, 0)
    }
  }

  /**
   * Last but not least, we have to remove the previously dragged items in the
   * dnd-moved callback.
   */
  vm.onMoved = function (list) {
    list = list.filter(item => !item.selected)
  }

  /**
   * We set the list into dragging state, meaning the items that are being
   * dragged are hidden. We also use the HTML5 API directly to set a custom
   * image, since otherwise only the one item that the user actually dragged
   * would be shown as drag image.
   */
  vm.onDragend = function (list) {
    list.dragging = false
  }

  /**
   * In the dnd-drop callback, we now have to handle the data array that we
   * sent above. We handle the insertion into the list ourselves. By returning
   * true, the dnd-list directive won't do the insertion itself.
   */
  vm.onDrop = function (list, items, index, ba, form) {
    form.$setDirty()
    if (items.filter((i) => i.$carouselId === ba.id).length !== items.length) {
      return false
    }
    items.forEach(item => { item.selected = false })
    list = list
      .slice(0, index)
      .concat(items)
      .concat(list.slice(index))
    ba.bannerBundles = list.filter(item => !item.selected)
      .map(item => item instanceof BannerBundle ? item : new BannerBundle(Object.assign(item, { $carouselId: ba.id })))
    return true
  }

  /**
   * Check exist platforms into banner bundle
   *
   * @memberof mwApp/shows.controller:BannerCarouselCtrl
   */
  vm.isEmptyPlatforms = function (ba) {
    return !!ba.bannerBundles.filter((bb) => !bb.platformTypes.length).length
  }

  /**
   * Check autoScrollEnabled handler
   *
   * @memberof mwApp/shows.controller:BannerCarouselCtrl
   */
  vm.checkScroll = (ba) => {
    if (!ba.autoScrollEnabled) {
      ba.autoScrollIn = 5
    }
  }

  /**
   * On/Off carousel
   *
   * @memberof mwApp/shows.controller:BannerCarouselCtrl
   * @params carousel Banner
   * @params event
   */
  vm.onOffCarousel = function (carousel, $event) {
    vm.stopEvent($event)

    if (!vm.hasAccess('editBannerCarousel')) return

    carousel.enabled = !carousel.enabled

    return carousel._onOff().then().catch(err => {
      alertLiteSvc.alertError(err.status === 403 ? { data: 'Please assign at least one banner' } : err)
    })
  }
}
